<div class="page-title-wrapper">
    <h1 class="page-title">{{ pageTitle }}</h1>
</div>

<div class="page-main">
    <div class="content-container">
        <tab [tabData]="tabData"></tab>

        <router-outlet></router-outlet>
    </div>
</div>

<footer page-footer role="contentinfo"></footer>
